export default __webpack_public_path__ + "static/media/607.177c6de4.png";